<template>
    <div>
        <div className="chart" style="height: 17vh; flex: 1" id="riverWaterQuality"></div>
    </div>
</template>

<script>
import * as echarts from "echarts/core";
import {
    TooltipComponent,
    TitleComponent,  // 新增：标题组件
    GridComponent    // 新增：网格组件
} from "echarts/components";
// 补充缺失的图表类型导入
import {
    PieChart,
    CustomChart,     // 新增：自定义图表
    BarChart,        // 新增：柱状图
    PictorialBarChart // 新增：象形柱图
} from "echarts/charts";
import {LabelLayout} from "echarts/features";
import {CanvasRenderer} from "echarts/renderers";

echarts.use([
    TooltipComponent,
    TitleComponent,
    GridComponent,
    PieChart,
    CustomChart,
    BarChart,
    PictorialBarChart,
    CanvasRenderer,
    LabelLayout
]);
export default {
    name: "riverWaterQuality",
    data(){
        return{
          riverWaterList:[
              {name:'I类',value:18.0},{name:'II类',value:14.0},
              {name:'III类',value:5.0},{name:'IV类',value:3.0},
              {name:'V类',value:2.0},{name:'劣V类',value:2.0},
              {name:'暂无数据',value:1.0},
          ]
      }
    },
    mounted() {
        this.initriverWaterQualityChart();
    },
    methods: {
        initriverWaterQualityChart() {
            const chartDom = document.getElementById("riverWaterQuality");
            if (!chartDom) return;
            chartDom.style.height = '35vh';
            chartDom.style.width = '100%';
            this.sewageChart = echarts.init(chartDom);
            var option;
            option = {
                color: ['#6552D5', '#70D9DA', '#54A8BF', '#3180C0', '#3067C0'],
                tooltip: {
                    trigger: "item",
                },
                series: [
                    {
                        radius: ['32%', '50%'],
                        center: ['50%', '45%'],
                        type: 'pie',
                        label: {
                            show: true,
                            formatter: ["{title|{b}}", "{percentage|{d}%}"].join("\n"),
                            rich: {
                                title: {
                                    lineHeight: 18,
                                    color: '#fff',
                                    borderWidth: 0,
                                    backgroundColor: 'transparent',
                                },
                                percentage: {
                                    fontSize: 12,
                                    color: '#fff',
                                },
                            },
                        },
                        labelLine: {
                            show: true,
                            color: "#fff",
                        },
                        emphasis: {
                            disabled: true
                        },
                        name: "",
                        data: this.riverWaterList,
                    },
                    {
                        radius: ['30%', '31%'],
                        center: ['50%', '45%'],
                        silent: true,
                        type: 'pie',
                        label: { show: false },
                        labelLine: { show: false },
                        animation: false,
                        tooltip: {
                            show: false
                        },
                        data: [{
                            value: 1,
                            itemStyle: {
                                color: "rgba(250,250,250,0.3)",
                            },
                        }],
                    }, {
                        name: '外边框',
                        type: 'pie',
                        clockwise: true,
                        center: ['50%', '45%'], // 外边框位置同步下移
                        radius: ['53%', '53%'],
                        label: { show: false },
                        data: [{
                            value: 9,
                            name: '',
                            itemStyle: {
                                borderWidth: 2,
                                borderColor: '#0b5263'
                            }
                        }]
                    }
                ]
            };
            option && this.sewageChart.setOption(option);
        },
    }
}
</script>

<style scoped>

</style>